import {
  BuildsIcon,
  DescriptionOutlinedIcon,
  FeaturesIcon,
  FileIcon,
  PlayCircleFilledWhiteOutlinedIcon,
  ReleasesIcon,
  SourceOutlinedIcon,
  StagesIcon,
  SuitesIcon,
  TestsIcon,
  UploadFileIcon,
} from '@/ui/primitives';
import type { ReactElement } from 'react';

const normaliseEntityLabel = (entityLabel: string): string =>
  entityLabel.trim().toLowerCase().replace(/\s+/g, ' ');

export const getDetailEditEntityDialogIcon = (entityLabel: string): ReactElement => {
  const label = normaliseEntityLabel(entityLabel);

  if (label.includes('release')) return <ReleasesIcon fontSize="small" />;
  if (label.includes('feature')) return <FeaturesIcon fontSize="small" />;
  if (label.includes('suite')) return <SuitesIcon fontSize="small" />;
  if (label.includes('test')) return <TestsIcon fontSize="small" />;
  if (label.includes('execution run'))
    return <PlayCircleFilledWhiteOutlinedIcon fontSize="small" />;
  if (label.includes('upload')) return <UploadFileIcon fontSize="small" />;
  if (label.includes('results file')) return <UploadFileIcon fontSize="small" />;
  if (label.includes('coverage')) return <SourceOutlinedIcon fontSize="small" />;
  if (label.includes('code')) return <SourceOutlinedIcon fontSize="small" />;
  if (label.includes('directory')) return <SourceOutlinedIcon fontSize="small" />;
  if (label.includes('file')) return <FileIcon fontSize="small" />;
  if (label.includes('pipeline')) return <BuildsIcon fontSize="small" />;
  if (label.includes('job')) return <BuildsIcon fontSize="small" />;
  if (label.includes('stage')) return <StagesIcon fontSize="small" />;
  if (label.includes('build')) return <BuildsIcon fontSize="small" />;

  return <DescriptionOutlinedIcon fontSize="small" />;
};
